require('../utils/gsap.min.js')
require('../utils/ScrollTrigger.min.js')
require('../utils/ScrollToPlugin.min.js')

const animations = {

init(){

    jQuery( document ).ready(function($) {

        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(ScrollToPlugin);

        gsap.utils.toArray('.fadein').forEach(fadein => {

            gsap.fromTo(fadein, { autoAlpha: 0, y: 50 }, {
                scrollTrigger: { trigger: fadein, start: "top 80%", once: true,
                },
                duration: 1, autoAlpha: 1, y: 0
            });
        });

        gsap.utils.toArray('.fade-in-from-left').forEach(fadein => {

            gsap.fromTo(fadein, { autoAlpha: 0, x: -50 }, {
                scrollTrigger: { trigger: fadein, start: "top 80%", once: true,
                },
                duration: 1, autoAlpha: 1, x: 0
            });
        });

        gsap.utils.toArray('.fade-in-from-right').forEach(fadein => {

            gsap.fromTo(fadein, { autoAlpha: 0, x: 50 }, {
                scrollTrigger: { trigger: fadein, start: "top 80%", once: true,
                },
                duration: 1, autoAlpha: 1, x: 0
            });
        });

        const scrollElements = gsap.utils.toArray('.fadeInList');
        scrollElements.forEach(element => {
            gsap.set(element, {
                opacity: 0,
                x: -10
            });

            element.anim = gsap.to(element, {
                duration: 0.5,
                paused: true,
                opacity: 1,
                x: 0
            });
        });

        function staggerPlayBatch(batch) {
            gsap.to(batch, { stagger: {
                    each: 0.5,
                    onStart: function() { this.targets()[0].anim.play() }
                }})
        }

        ScrollTrigger.batch(scrollElements, {
            onEnter: staggerPlayBatch,
            start: "top 80%"
        });

        setTimeout(function(){
            ScrollTrigger.refresh()
        },500);

        $('.scrollTo').on('click', function(){
            preventDefault();
            gsap.to($('a', this).attr('href'), {duration: 1, scrollTo: 250});
        });

        ScrollTrigger.create({
            start: 'top',
            end: 99999,
            toggleClass: {className: 'top-navigation--scrolled', targets: '.top-navigation'}
        });

    })
}

}

export default animations;